import SettingsSubHeader from './SettingsSubHeader'

export default SettingsSubHeader
